import SidebarSectionAction from './SidebarSectionAction';
import SidebarSectionActionMui from './SidebarSectionActionMui';
import SidebarSectionContent from './SidebarSectionContent';
import SidebarSectionContentMui from './SidebarSectionContentMui';
import SidebarSectionDescription from './SidebarSectionDescription';
import SidebarSectionDescriptionMui from './SidebarSectionDescriptionMui';
import SidebarSectionHeader from './SidebarSectionHeader';
import SidebarSectionHeaderMui from './SidebarSectionHeaderMui';
import SidebarSectionRoot from './SidebarSectionRoot';
import SidebarSectionRootMui from './SidebarSectionRootMui';
import SidebarSectionTitle from './SidebarSectionTitle';
import SidebarSectionTitleMui from './SidebarSectionTitleMui';

export * from './SidebarValue';
export * from './SidebarValueMui';
export const SidebarSection = {
  Root: SidebarSectionRoot,
  Header: SidebarSectionHeader,
  Content: SidebarSectionContent,
  Title: SidebarSectionTitle,
  Description: SidebarSectionDescription,
  Action: SidebarSectionAction,
};
export const SidebarSectionMui = {
  Root: SidebarSectionRootMui,
  Header: SidebarSectionHeaderMui,
  Content: SidebarSectionContentMui,
  Title: SidebarSectionTitleMui,
  Description: SidebarSectionDescriptionMui,
  Action: SidebarSectionActionMui,
};
